import { apiClient } from "../../../api/client";
import * as ActionType from "./redeem.type";
import { setToast } from "../../../util/toast";

export const getRedeem = () => async (dispatch) => {
  const res = await apiClient.get("redeem/getRedeemRequest");
  if (res.ok) {
    dispatch({ type: ActionType.GET_REDEEM_REQUEST, payload: res.data });
  } else {
    console.error(res.message);
  }
};

export const action = (redeemId) => async (dispatch) => {
  const res = await apiClient.patch("redeem/action", { redeemId });
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.REDEEM_ACTION, payload: redeemId });
    setToast("success", "Redeem action completed successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getWithdrawalRequest =
  (start, limit, startDate, endDate, status) => async (dispatch) => {
    const res = await apiClient.get(
      `redeem/getWithdrawalRequest?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&status=${status}`
    );
    if (res.ok) {
      dispatch({
        type: ActionType.GET_SELLER_WITHDRAWAL_REQUEST,
        payload: res.data,
      });
    } else {
      console.error(res.message);
    }
  };

export const getAdminWallet = () => async (dispatch) => {
  const res = await apiClient.get("redeem/adminWallet");
  if (res.ok) {
    dispatch({ type: ActionType.ADMIN_WALLET, payload: res.data?.wallet });
  } else {
    console.error(res.message);
  }
};

export const getAdminEarning =
  (start, limit, startDate, endDate) => async (dispatch) => {
    const res = await apiClient.get(
      `redeem/getAdminEarning?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
    );
    if (res.ok) {
      dispatch({ type: ActionType.GET_ADMIN_EARNING, payload: res.data });
    } else {
      console.error(res.message);
    }
  };

export const acceptWithdrawalRequest = (data) => async (dispatch) => {
  const res = await apiClient.patch("redeem/acceptWithdrawalRequest", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.ACCEPTSELLERWITHDRAWALREQUEST,
      payload: data.requestId,
    });
    setToast("success", "Withdrawal request accepted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const declineWithdrawalRequest = (data) => async (dispatch) => {
  const res = await apiClient.patch("redeem/declineWithdrawalRequest", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DECLINESELLERWITHDRAWALREQUEST,
      payload: data.requestId,
    });
    setToast("success", "Withdrawal request declined successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
